var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.37 5.39L13.51 2.78C12.65 2.4 11.35 2.4 10.49 2.78L4.63 5.39C3.15 6.05 2.93 6.95 2.93 7.43C2.93 7.91 3.15 8.81 4.63 9.47L10.49 12.08C10.92 12.27 11.46 12.37 12 12.37C12.54 12.37 13.08 12.27 13.51 12.08L19.37 9.47C20.85 8.81 21.07 7.91 21.07 7.43C21.07 6.95 20.86 6.05 19.37 5.39Z",
    fill: "#B2DDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.54C11.62 17.54 11.24 17.46 10.89 17.31L4.15 14.31C3.12 13.85 2.32 12.62 2.32 11.49C2.32 11.08 2.65 10.75 3.06 10.75C3.47 10.75 3.8 11.08 3.8 11.49C3.8 12.03 4.25 12.73 4.75 12.95L11.49 15.95C11.81 16.09 12.18 16.09 12.5 15.95L19.24 12.95C19.74 12.73 20.19 12.04 20.19 11.49C20.19 11.08 20.52 10.75 20.93 10.75C21.34 10.75 21.67 11.08 21.67 11.49C21.67 12.61 20.87 13.85 19.84 14.31L13.1 17.31C12.76 17.46 12.38 17.54 12 17.54Z",
    fill: "#B2DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C11.62 22.5 11.24 22.42 10.89 22.27L4.15 19.27C3.04 18.78 2.32 17.67 2.32 16.45C2.32 16.04 2.65 15.71 3.06 15.71C3.47 15.71 3.8 16.04 3.8 16.45C3.8 17.08 4.17 17.65 4.75 17.91L11.49 20.91C11.81 21.05 12.18 21.05 12.5 20.91L19.24 17.91C19.81 17.66 20.19 17.08 20.19 16.45C20.19 16.04 20.52 15.71 20.93 15.71C21.34 15.71 21.67 16.04 21.67 16.45C21.67 17.67 20.95 18.77 19.84 19.27L13.1 22.27C12.76 22.42 12.38 22.5 12 22.5Z",
    fill: "#B2DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipcode);
export default __webpack_public_path__ + "static/media/Zipcode.32c9ba39c9468f3e333eb74d5ab13d30.svg";
export { ForwardRef as ReactComponent };